import { getTenantFromPath } from '../utils/common';

export const tokenOptionsInitial = {
  accessToken: '',
  refreshToken: '',
  token_type: '',
  clientTokenTime: 0,
};

export const loginInitialState = {
  username: null,
  password: null,
  // флаг используется для того, чтобы знать что фронт ждет ответ от сервера по логину.
  loggingIn: false,
  authenticated: false,
  checking: false,
  tenants: [],
  tenantId: '',
  tokenOptions: tokenOptionsInitial,
};

const login = (state = loginInitialState, action) => {
  switch (action.type) {
    case 'SET_TENANT_ID':
      return {
        ...state,
        tenantId:
          [...(state.tenants || []), ''].find((t) => t === action.tenantId) || state.tenantId,
      };

    case 'UPDATE_LOCATION':
      return {
        ...state,
        tenantId:
          [...(state.tenants || []), ''].find((t) => t === getTenantFromPath(action.location)) ||
          state.tenantId,
      };

    case 'CHANGE_USERNAME':
      return {
        ...state,
        username: action.username,
      };

    case 'CHANGE_PASSWORD':
      return {
        ...state,
        password: action.password,
      };

    case 'LOGIN':
      return {
        ...state,
        loggingIn: true,
      };

    case 'LOGOUT':
      return {
        ...loginInitialState,
      };

    case 'LOGIN_SUCCESS':
      return {
        ...state,
        loggingIn: false,
        authenticated: true,
        password: null,
        tenants: action.tenants,
        tokenOptions: {
          clientTokenTime: action.clientTokenTime,
          accessToken: action.accessToken,
          refreshToken: action.refreshToken,
          tokenType: action.tokenType,
        },
      };

    case 'UPDATE_LOGIN_FROM_LOCAL_STORAGE':
      return {
        ...state,
        username: action.username,
        authenticated: action.authenticated,
        tenants: action.tenants,
        tokenOptions: {
          ...action.tokenOptions,
        },
      };

    case 'UPDATE_TOKEN_SUCCESS':
      return {
        ...state,
        tokenOptions: {
          clientTokenTime: action.clientTokenTime,
          accessToken: action.accessToken,
          refreshToken: action.refreshToken,
          tokenType: action.tokenType,
        },
      };

    case 'LOGIN_FAILURE':
      return {
        ...state,
        loggingIn: false,
        password: null,
      };

    default:
      return state;
  }
};

export default login;

export const getTenantId = (state) => state.tenantId;

export const getTenants = (state) => state.tenants;

export const getUsername = (state) => state.username;

export const getPassword = (state) => state.password;

export const isLoggingIn = (state) => state.loggingIn;

export const isAuthenticated = (state) => state.authenticated;

export const getTokenOptions = (state) => state.tokenOptions;
